<template>
 	<div>
    	<div v-if="authenticated">
    		signed in dashboard
    	</div>
 	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
 	export default {
    	name: 'Home',
    	components: {
      		
    	},
    	computed: {
	    	...mapGetters({
	        	authenticated: 'auth/authenticated',
	        	user: 'auth/user',
	      	})
	    },
	    mounted() {

	    }
  }
</script>
